import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { Organization } from '@/types/organization';

export async function getOrganizations(): Promise<Organization[]> {
  try {
    const snapshot = await getDocs(collection(db, 'organizations'));
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate(),
      updatedAt: doc.data().updatedAt?.toDate()
    })) as Organization[];
  } catch (error) {
    handleFirebaseError(error, 'Error fetching organizations');
    return [];
  }
}